
<template>
  <div>
    <v-container grid-list-xs>
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Consolidações</div>
        </v-card-title>
        <v-card-text>
          <consolidation-list></consolidation-list>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'PageConsolidationList',
  components: {
    ConsolidationList: () => import('@/components/consolidation/List.vue'),
  },
  data() {
    return {
      
    }
  },
  methods: {
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>